module.exports = __webpack_public_path__ + "img/icon6.b33a3a25.png";